<template>
  <div>
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input" @click="focusRef" :class="hasValue">
      <input type="text"
             :class="{inputClass, noIcons: !haveIcon}"
             ref="input"
             :placeholder="placeholderAsProp"
             v-model="content"
             v-on:input="updateValue($event.target.value)"
             v-on:keydown="handleKeyDown"
             v-on:keypress="handleKeyPress"
      />
      <!--
            <span class="input&#45;&#45;placeholder" v-if="hasPlaceholder">{{placeholderAsProp}}</span>
      -->
    </div>
  </div>
</template>
<script>
  import textInput from './text-input';
  import {checkAge, checkBirthDate} from '../helpers/field-checker.helper';
  import {F_ERR_ENUM} from '../enum/field-error.enum';

  export default {
    extends: textInput,
    name: 'birthdate-input',
    methods: {
      computeErrors() {
        if (!(checkBirthDate(this.content)) && this.content.length > 0) {
          this.setError(F_ERR_ENUM.INCORRECT, this.$t('birthdate-input.invalidDate'));
          return;
        }
        if (checkBirthDate(this.content) && !checkAge(this.content)) {
          this.setError(F_ERR_ENUM.INCORRECT, this.$t('birthdate-input.invalidAge'));
          return;
        }
        this.setError(F_ERR_ENUM.INCORRECT, null);
      },
      updateValue(value) {
        this.content = value;
        this.$emit('input', value);
        if (this.useDynamicErrors) {
          this._computeErrors();
          return;
        }
        if (this.usePseudoDynamicErrors && this.hasError) {
          this._computeErrors();
        }
      },
      handleKeyDown(e) {
        const currentCode = e.which || e.code;
        let currentKey = e.key;
        if (currentKey === "Unidentified") {
          currentKey = String.fromCharCode(currentCode);
        }
        if (currentKey === 'Backspace') {
          return;
        }

        const regexTest = /^\d$/;
        const regexPerPosition = {
          0: /^[0-3]$/,
          1: /^[0-9]$/,
          2: null,
          3: /^[0-1]$/,
          4: /^[0-9]$/,
          5: null,
          6: /^[1-2]$/,
          7: /^[0-9]$/,
          8: /^[0-9]$/,
          9: /^[0-9]$/,
        };
        let currentPosition = this.content.length;

        if (regexPerPosition[currentPosition] === null) {
          this.content = this.content + '/';
          currentPosition += 1;
        }
        if (!regexPerPosition[currentPosition] || !regexPerPosition[currentPosition].test(currentKey)) {
          e.preventDefault();
        }
        if (!regexTest.test(currentKey)) {
          e.preventDefault();
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/birthdate-input.vue